import LazyLoad from 'react-lazyload';
import Button from '@alltrails/shared/denali/components/Button';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { LanguageSupportUtil } from 'utils/language_support_util';
import { FormattedMessage, useIntl } from 'react-intl';
import useUser from 'hooks/useUser';
import * as styles from './styles/styles.module.scss';
import logoPro from './logo_pro.png';

const BG_IMAGE_BASE_URL = 'https://cdn-assets.alltrails.com/assets/images/homepage/pro_upsell_no_auth';

export default function ProUpsellNoAuth() {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();

  const upperContainerImageUrl = `${BG_IMAGE_BASE_URL}/bg_mobile_${languageRegionCode}`;
  const contentContainerImageUrl = `${BG_IMAGE_BASE_URL}/bg_desktop_${languageRegionCode}`;

  const bgImageAlt = intl.formatMessage({ defaultMessage: 'Person holding a phone using the AllTrails app' });

  return (
    <div className={styles.container}>
      <LazyLoad>
        <div className={styles.upperContainer}>
          <picture>
            <source srcSet={`${upperContainerImageUrl}.avif`} type="image/avif" />
            <source srcSet={`${upperContainerImageUrl}.webp`} type="image/webp" />
            <img src={`${upperContainerImageUrl}.jpg`} className={styles.upperContainerBgImage} alt={bgImageAlt} />
          </picture>
        </div>
      </LazyLoad>
      <div className={styles.contentContainer}>
        <picture>
          <source srcSet={`${contentContainerImageUrl}.avif`} type="image/avif" />
          <source srcSet={`${contentContainerImageUrl}.webp`} type="image/webp" />
          <img src={`${contentContainerImageUrl}.jpg`} className={styles.contentContainerBgImage} alt={bgImageAlt} />
        </picture>
        <LazyLoad>
          <img className={styles.logoProImage} src={logoPro} alt="" />
        </LazyLoad>
        <h2 className={styles.title}>
          <FormattedMessage defaultMessage="Stay on track while offline with Pro" />
        </h2>
        <p className={styles.text}>
          <FormattedMessage defaultMessage="No cell service? No problem. Download offline maps or print a backup copy — and with off-route notifications, you’ll never miss a turn." />
        </p>
        <div className={styles.buyLink}>
          <Button
            text={
              !user || user.isPromoEligible ? <FormattedMessage defaultMessage="Try Pro for Free" /> : <FormattedMessage defaultMessage="Buy Pro" />
            }
            linkInfo={{ href: LanguageSupportUtil.wrapUrlSafe('/pro?ref=homepage_pro_proupsellnoauth', languageRegionCode) }}
            onClick={() => {
              /* do nothing */
            }}
            testId="try-free-or-buy-pro"
            variant="primary"
          />
        </div>
      </div>
    </div>
  );
}
